module.exports = __webpack_public_path__ + "img/img_logo_icon.36162ecb.svg";